import { render, staticRenderFns } from "./way.vue?vue&type=template&id=672c40ca&scoped=true&"
import script from "./way.vue?vue&type=script&lang=js&"
export * from "./way.vue?vue&type=script&lang=js&"
import style0 from "./way.vue?vue&type=style&index=0&id=672c40ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c40ca",
  null
  
)

export default component.exports